import React from 'react';
import moment from 'moment';

import Hero from '../components/hero';
import FeaturedEvents from '../components/events/featured-events';
import EventsGallery from '../components/events/event-gallery';
import BottomCta from '../components/bottom-cta';

const EventsTemplate = ({ events, featured }) => {
	let upcomingEvents = [];
	let pastEvents = [];
	let featuredEvent;
	let nonFeaturedEvents = [...events];
	let i, j;

	// Get featured event from settings and remove from events
	for (i in events) {
		if (events[i].title === featured) {
			featuredEvent = events[i];
			nonFeaturedEvents.splice(i, 1);
		}
	}

	let now = moment();
	// Split events into past and upcoming
	for (j in nonFeaturedEvents) {
		if (moment(nonFeaturedEvents[j].date).isBefore(now)) {
			pastEvents.push(nonFeaturedEvents[j]);
		} else {
			upcomingEvents.push(nonFeaturedEvents[j]);
		}
	}

	// Reverse past Events to show in most recent order
	pastEvents = pastEvents.reverse();

	return (
		<div>
			<Hero
				img="/img/Events_Masthead.svg"
				mobileImg="/img/events-mobile.svg"
				alt="Group of people illustration"
				title="Start Talking"
				greenTitle="Events"
				subtext="Learn more about our community-based events that help raise funds and awareness for mental health."
				className="text events"
			/>
			<FeaturedEvents
				event={featuredEvent}
				color="teal"
				title="Featured Event"
			/>
			<EventsGallery events={upcomingEvents} title="Upcoming Events" />
			{!!pastEvents.length ? (
				<EventsGallery events={pastEvents} title="Past Events" bg="dark" />
			) : (
				undefined
			)}
			<BottomCta
				bg="teal"
				bimg="/img/Green_Blob.svg"
				text1="Interested in hosting an event for the"
				text2="campaign?"
				textWidth="70%"
				colored={{ text: 'Start Talking', color: 'green' }}
				cta={{ text: 'CONTACT US', link: '/contact/?interest=host#form' }}
			/>
		</div>
	);
};

export default EventsTemplate;
